import React from 'react'
import { getCatalogLabel } from '../../constants/ticket'

// أقسام التذاكر بعدّاداتها، بشكل شريط الحالات بس أصغر — بيظهر الأقسام اللي فيها تذاكر بس.
// sectionCounts: { sectionKey: count }، والضغط على قسم بيفلتر التذاكر بيه (والضغط عليه تاني بيلغي الفلتر).
const TicketSectionChips = ({ lang = 'ar', sections, sectionCounts = {}, activeSection = 'all', onSectionChange }) => {
    const isAr = lang === 'ar';
    const chips = Object.entries(sectionCounts || {})
        .filter(([, count]) => Number(count) > 0)
        .map(([key, count]) => ({ key, count: Number(count), label: getCatalogLabel(sections, key, lang) || key }))
        .sort((a, b) => b.count - a.count);
    if (!chips.length) return null;

    const chip = ({ key, label, count }) => {
        const isActive = activeSection === key;
        return (
            <button
                key={key}
                type="button"
                data-testid="section-chip"
                aria-pressed={isActive}
                onClick={() => onSectionChange?.(isActive && key !== 'all' ? 'all' : key)}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '4px 9px',
                    borderRadius: 999,
                    border: isActive ? '1px solid #4f46e5' : '1px solid #e2e8f0',
                    background: isActive ? '#eef2ff' : '#fff',
                    cursor: 'pointer'
                }}
            >
                <span style={{ fontSize: 11, fontWeight: 800, color: '#0f172a' }}>{label}</span>
                <span style={{ minWidth: 20, height: 16, padding: '0 6px', borderRadius: 999, background: '#f1f5f9', color: '#334155', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 900 }}>
                    {count}
                </span>
            </button>
        );
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
            <span style={{ fontSize: 11, fontWeight: 800, color: '#94a3b8' }}>{isAr ? 'الأقسام:' : 'Sections:'}</span>
            {chip({ key: 'all', label: isAr ? 'كل الأقسام' : 'All sections', count: chips.reduce((sum, item) => sum + item.count, 0) })}
            {chips.map(chip)}
        </div>
    );
};

export default TicketSectionChips
